import { render, staticRenderFns } from "./PopMgr.vue?vue&type=template&id=3882c3b4&scoped=true&"
import script from "./PopMgr.vue?vue&type=script&lang=js&"
export * from "./PopMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882c3b4",
  null
  
)

export default component.exports